import Image from "next/image";
import getImageFromStrapi from "../../utils/api/getImageFromStrapi";
import { formatDate } from "../../utils/utils";
import Link from "next/link";
import { InternalLinkIcon, ExternalLinkSimpleIcon } from "../atoms/Icons";
import { prefix } from "../../utils/utils";
export default function CardMedia({
  title,
  image,
  date,
  link,
  type,
  media_type,
}) {
  return (
    <div className="relative block h-full group p-16 640:p-20 bg-white rounded-xxxs overlfow-hidden w-full">
      <div className="flex flex-row gap-x-16 640:gap-x-20">
        <Image
          className="block max-h-fit w-72 640:w-128 aspect-[1/1] object-cover rounded-xxxs"
          src={getImageFromStrapi(image)}
          width={128}
          height={128}
          sizes="33vw"
        />
        <div className="flex flex-col gap-y-12">
          {title && (
            <span className="text-xs 640:text-s font-medium tracking-05 leading-145">
              {title}
            </span>
          )}
          <span className="text-xxxs font-medium tracking-05">
            {formatDate(date)} - {media_type}
          </span>
          <Link
            href={prefix(link)}
            as={prefix(link)}
            target={type === "internal" ? "_self" : "_blank"}
            aria-label={`Read article: ${title || ""}`}
            className="stretched-link btn-link flex items-center gap-8 text-gray-900 rounded-xxxs font-medium text-xxs"
          >
            <span className="underline decoration-transparent media-hover:group-hover:decoration-gray-900 underline-offset-4 duration-300">
              Read article
            </span>
            {type === "internal" ? (
              <InternalLinkIcon extraClass="stroke-theme-color" />
            ) : (
              <ExternalLinkSimpleIcon extraClass="stroke-theme-color" />
            )}
          </Link>
        </div>
      </div>
    </div>
  );
}
